import { useQuery } from "@apollo/react-hooks";

import { AgreementDocuments } from "../types";
import { AgreementInstructorDocument } from "@hubcapp/types";
import getCustomerAndFranchiseDocumentsByPerson from "../graph-ql/getCustomerAndFranchiseDocumentsByPerson.graphql";

const useQueryGetCustomerAndFranchiseDocumentsByPerson = (personKey: string) =>
  useQuery<{
    getCustomerAndFranchiseDocumentsByPerson: {
      customerDocuments: AgreementInstructorDocument[];
      franchiseDocuments: AgreementDocuments[];
    };
  }>(getCustomerAndFranchiseDocumentsByPerson, {
    variables: { personKey },
  });

export default useQueryGetCustomerAndFranchiseDocumentsByPerson;
